import { regexTypes } from "@certn/utils";
import { TFunction } from "i18next";
import { array, string } from "yup";

/**
 * Yup fragment: primary_reviewer required when `role` equals the Requestor role id.
 */
export function primaryReviewerField(
  requestorRoleId: string | undefined,
  t: TFunction,
  roleFieldName = "role"
) {
  return string()
    .nullable()
    .when(roleFieldName, {
      is: (roleId: string) =>
        Boolean(requestorRoleId) && roleId === requestorRoleId,
      then: (schema) => schema.required(t("Primary reviewer is required")),
      otherwise: (schema) => schema.nullable(),
    });
}

/**
 * Yup fragment: additional notification emails for Requestor (max length, format, unique).
 */
export function additionalNotificationEmailsField(t: TFunction) {
  return array()
    .max(100, t("You cannot have more than 100 recipients."))
    .test(
      "invalidEmail",
      t("One or more entries is not using a valid email format."),
      (inputStringArray) => {
        return inputStringArray?.every((item) => {
          return string()
            .email()
            .matches(regexTypes.checkMultipleEmails)
            .isValidSync(item);
        });
      }
    )
    .test("uniqueOnly", t("Every email must be unique."), (list) => {
      return list?.length === new Set(list).size;
    });
}
